import React from 'react';

const RankLegend = () => {
  // Create a linear gradient for a continuous scale
  return (
    <div className="mt-0 bg-white rounded shadow w-full">
      <div className="flex flex-col">
        {/* Text description */}
        <div className="flex justify-between mt-0 text-xs">
          <span className="font-medium text-green-700">Higher Ranked School</span>
          <span className="font-medium text-red-700">Lower Ranked School</span>
        </div>
        {/* Continuous gradient scale bar */}
        <div 
          className="h-6 w-full rounded-sm mb-1"
          style={{ 
            background: 'linear-gradient(to right, #1a9850, #66bd63, #a6d96a, #fdae61, #f46d43, #d73027)' 
          }}
        />
        
        {/* Labels */}
        <div className="flex w-full justify-between text-xs mt-1">
          <span>1</span>
          <span>50</span>
          <span>100</span>
          <span>200</span>
          <span>300</span>
          <span>400</span>
          <span>500+</span>
        </div>
      </div>
    </div>
  );
};

export default RankLegend;